<template>
  <click-to-edit
    v-model="scope.row.scale.point"
    :disabled="!isFieldAvailableForEdit(scope.row, 'scale.point')"
    placeholder=""
    digits-only
    @input="saveElementPropChange(scope.row, 'scale', {point:$event})"
  ></click-to-edit>
</template>

<script>

import ClickToEdit from "@/components/ClickToEdit";
import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";

export default {
  name: 'element-percent-table-column',
  components: {ClickToEdit},
  mixins: [ElementPropTableColumn],
  props: {},
  data() {
    return {
    }
  },
  computed: {},
  methods: {
  }
}

</script>

<style>

</style>
